import styled from 'styled-components';
export const Container = styled.section`
  position: relative;
`;
export const UserInfo = styled.section`
  margin: -2rem auto;
  max-width: 65.5rem;
`;
export const Main = styled.section<{
  $hasTabs?: boolean;
}>`
  margin: 0 auto;
  padding: ${props => props.$hasTabs ? '3.5rem' : '6.25rem'} 1rem 2rem 1rem;
  max-width: 54rem;
`;